import { Component } from '@angular/core';

@Component({
  selector: 'app-damage-policy',
  templateUrl: './damage-policy.component.html',
  styleUrl: './damage-policy.component.scss'
})
export class DamagePolicyComponent {

}
